import script from "./VVVSignaturePad.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVSignaturePad.vue?vue&type=script&setup=true&lang=js"

import "./VVVSignaturePad.vue?vue&type=style&index=0&id=6d72cd3c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d72cd3c"]])

export default __exports__